import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  ElementRef,
  inject,
  computed,
  TemplateRef,
  viewChild,
  signal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import {
  concatMap,
  from,
  of,
  Subscription,
  switchMap,
  filter,
  take,
  tap,
  firstValueFrom,
  delay
} from 'rxjs';
import { Feature } from 'ol';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/models/user.model';
import Shepherd from 'shepherd.js';
import { AuthService } from 'src/app/services/auth.service';
import { mapService } from 'src/app/services/map.service';
import { PropertyService } from 'src/app/services/property.service';
import { EskToolService } from 'src/app/shared/features/esk-tool/EskTool.service';

import { PaddockService } from 'src/app/services/paddock.service';

import { DropDownService } from 'src/app/services/dropdown.service';
import SidebarEsk from 'src/app/_helpers/sidebar_esk';
import { ModalService } from 'src/app/services/modal.service';
import { EventBusService } from 'src/app/services/EventBus.service';
import { FenceService } from 'src/app/services/fence.service';
import { ReportingService } from 'src/app/services/reporting.service';
import {
  ReportingToolType,
  TreeMapperCustomEvents
} from 'src/app/_helpers/enums';
import { DigitizePaddockComponent } from './tools/digitize-paddock/digitize-paddock.component';
import {
  DigitizeFenceComponent,
  FenceCreatedEvent
} from './tools/digitize-fence/digitize-fence.component';
import { SelectPropertyComponent } from './tools/select-property/select-property.component';
import VectorLayer from 'ol/layer/Vector';
import { MatDialog } from '@angular/material/dialog';
import {
  WelcomeDialogComponent,
  WelcomeDialogResult
} from './dialogs/welcome/welcome-dialog.component';
import { CreatePropertyComponent } from './dialogs/property/create-property/create-property.component';
import { EditPropertyComponent } from './dialogs/property/edit-property/edit-property.component';
import { CreatePaddockComponent } from './dialogs/paddock/create-paddock/create-paddock.component';
import { EditPaddockComponent } from './dialogs/paddock/edit-paddock/edit-paddock.component';
import { CreateFenceComponent } from './dialogs/fence/create-fence/create-fence.component';
import { EditFenceComponent } from './dialogs/fence/edit-fence/edit-fence.component';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { boolean } from 'mathjs';
import { AttributeOverlayComponent } from './tools/attribute-overlay/attribute-overlay.component';
import {
  CalculateArea,
  ConvertWktToFeature
} from 'src/app/_helpers/transformations';

import VectorSource from 'ol/source/Vector';
import { PropertyDexie } from 'src/app/models/property.model';
import { PaddockDexie } from 'src/app/models/paddock.model';
import { FenceDexie } from 'src/app/models/fence.model';
import { EnterpriseReportService } from 'src/app/services/enterpriseReport.service';
import { EnterpriseReport } from 'src/app/models/enterpriseReport.model';
import { TopexReportService } from 'src/app/services/topexReport.service';
import { TopexReportComponent } from './dialogs/topex-report/topex-report.component';
import {
  ITopexReport,
  ITopexReportData
} from 'src/app/interfaces/topexReport.interface';
import { TopexReport } from 'src/app/models/topexReport.model';
import { IDssReport } from 'src/app/interfaces/dssReport.Interface';
import { DssReportComponent } from './dialogs/dss-report/dss-report.component';
import { OfflineService } from 'src/app/services/offline.service';
import { IForestDescriptionReport } from 'src/app/interfaces/forestDescriptionReport.Interface';
import { ForestClassReportService } from 'src/app/services/forestClassesReport.service';
import { ForestDescriptionReportComponent } from './dialogs/forest-description-report/forest-description-report.component';
import { AboutDialogComponent } from '../../shared/components/about-dialog/about-dialog.component';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';

// Import child components
import { ActivePropertyComponent } from './active-property/active-property.component';
import { BaseFloatComponent } from './layer-switcher/base-float/base-float.component';
import { ZoomComponent } from './tools/zoom/zoom.component';
import { GpsComponent } from './tools/gps/gps.component';
import { MeasureComponent } from './ui/measure/measure.component';
import { GraticleComponent } from './tools/graticle/graticle.component';
import { SelectComponent } from './ui/select/select.component';
import { GeocodeComponent } from './ui/geocode/geocode.component';
import { AnalysisGroupComponent } from './layer-switcher/analysis-group/analysis-group.component';
import { TopexLayerComponent } from './layer-switcher/topex-layer/topex-layer.component';
import { ForestClassLayerComponent } from './layer-switcher/forest-class-layer/forest-class-layer.component';
import { LayerGroupComponent } from './layer-switcher/layer-group/layer-group.component';
import { BaseGroupComponent } from './layer-switcher/base-group/base-group.component';
import { ReportCardComponent } from './reporting/report-card/report-card.component';

// Import pipes
import { TruncateTextPipe } from '../../pipes/truncate-text.pipe';
import { RoundingPipe } from '../../pipes/rounding.pipe';

// Import directives
import { TooltipDirective } from '../../components/shared/directives/tooltip/tooltip.directive';
import { RoleDirective } from '../../components/shared/directives/role/role.directive';
import { PropertySelectComponent } from '../property-select/property-select.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidebarItemComponent } from './sidebar/components/sidebar-page/sidebar-page.component';
import { SidebarService } from './sidebar/data-access/sidebar.service';
import { HeaderService } from './sidebar/features/header/data-access/header.service';
import { SidebarOverlayComponent } from './sidebar/sidebar-overlay.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { ToolbarComponent } from '../../shared/components/toolbar/toolbar.component';
import { NgpDialogManager } from 'ng-primitives/dialog';

import { offset } from '@floating-ui/dom';
import { createTour } from './tour-setup';
import { DialogComponent } from '@aetherion/ui';
import { PineEconomicAnalysisToolComponent } from './dialogs/pine-economic-analysis-tool/pine-economic-analysis-tool.component';
import { PineEconomicAnalysisToolService } from '../../services/pine-economic-analysis-tool.service';
import { PeatReport } from '../../models/PEAT Tool/peat-report.model';
import { AccuTaskResponse } from '../../models/PEAT Tool/accu-task-response.model';

interface report {
  name: string;
  data: EnterpriseReport;
}

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  animations: [
    trigger('slideFadeInOut', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateY(100%)'
        })
      ),
      transition('void => *', animate('200ms ease-in-out')),
      transition('* => void', animate('200ms ease-in-out'))
    ])
  ],
  standalone: true,
  providers: [SidebarService, HeaderService],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    // Child components
    ActivePropertyComponent,
    SelectPropertyComponent,
    BaseFloatComponent,
    ZoomComponent,
    GpsComponent,
    MeasureComponent,
    GraticleComponent,
    SelectComponent,
    GeocodeComponent,
    TopexLayerComponent,
    AnalysisGroupComponent,
    TopexLayerComponent,
    ForestClassLayerComponent,
    LayerGroupComponent,
    BaseGroupComponent,
    ReportCardComponent,
    DigitizeFenceComponent,
    DigitizePaddockComponent,
    SidebarComponent,
    SidebarOverlayComponent,
    SidebarItemComponent,
    ToolbarComponent,
    DialogComponent,
    // Pipes
    TruncateTextPipe,
    RoundingPipe,
    // Directives
    TooltipDirective,
    RoleDirective
  ]
})
export class MapComponent implements OnInit, AfterViewInit, OnDestroy {
  mapService = inject(mapService);
  private authService = inject(AuthService);
  private propertyService = inject(PropertyService);
  private route = inject(ActivatedRoute);
  paddockService = inject(PaddockService);
  fenceService = inject(FenceService);
  private modalService = inject(ModalService);
  private eventBusService = inject(EventBusService);
  private router = inject(Router);
  private reportingService = inject(ReportingService);
  dialog = inject(MatDialog);
  private tokenService = inject(TokenStorageService);
  private enterpriseReportService = inject(EnterpriseReportService);
  private topexReportService = inject(TopexReportService);
  connectionService = inject(OfflineService);
  private forestService = inject(ForestClassReportService);
  private eskToolService = inject(EskToolService);

  private dialogManager = inject(NgpDialogManager);
  private sidebarService = inject(SidebarService);
  private dialogRef = viewChild<TemplateRef<any>>('dialog');
  private peatService = inject(PineEconomicAnalysisToolService);

  geolocation: Geolocation;
  propertyTool: boolean;

  private subscriptions: Subscription = new Subscription();

  zoomLevel: Number = 0;
  cadasterRequiredZoomLevel: Number = 9;

  @ViewChild(DigitizePaddockComponent)
  digitizePaddockComponent: DigitizePaddockComponent;

  @ViewChild(DigitizeFenceComponent)
  digitizeFenceComponent: DigitizeFenceComponent;

  @ViewChild(SelectPropertyComponent)
  selectPropertyComponent: SelectPropertyComponent;

  @ViewChild('addAttributeOverlayHere', {
    static: false,
    read: ViewContainerRef
  })
  attributeOverlayTarget: ViewContainerRef;
  private attributeComponentRef: ComponentRef<AttributeOverlayComponent>;

  @ViewChild('mapElementRef', { static: true }) mapElementRef: ElementRef;

  reportingTargets: Set<PropertyDexie | PaddockDexie> = new Set();

  reportToolType: any = 0;
  alertMessage: string;
  user: User;
  featureSelected: boolean;
  selectedPropertyFeatures: Array<Feature<any>>;
  tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      classes: 'shepherd-theme-custom',
      scrollTo: true,
      floatingUIOptions: {
        middleware: [offset(10)]
      }
    }
  });

  property: PropertyDexie = new PropertyDexie();
  activeProperty_old: PropertyDexie = new PropertyDexie();

  activeProperty = toSignal<PropertyDexie | null>(
    this.propertyService.activeProperty
  );

  isActivePropertySelected = computed(() => this.activeProperty() != null);

  // Track if any esk-tool is active using the EskToolService
  isAnyEskToolActive = toSignal(this.eskToolService.toolActiveChanges(), {
    initialValue: false
  });

  dontShowAgain = signal(false);
  startHelp = signal(true);

  handleClose(closeFn: () => void) {
    closeFn();

    if (this.dontShowAgain()) {
      localStorage.setItem('showWelcome', 'false');
    }

    if (this.startHelp()) {
      this.tour.start();
    }
  }

  activePaddock: PaddockDexie = new PaddockDexie();
  activeFence: FenceDexie = new FenceDexie();

  reportingToolType: ReportingToolType = ReportingToolType.CROP_REPORT;

  activeFeature: Feature<any>;
  processingWindow: HTMLElement;
  processing: boolean = false;
  processingText: any;
  processingLayerText: string = '';
  paddocks: Array<PaddockDexie> = [];
  fences: Array<FenceDexie> = [];
  properties: Array<PropertyDexie> = [];

  // Computed property to sort properties with active one first
  sortedProperties = computed(() => {
    const activeProperty = this.activeProperty();
    if (!activeProperty) {
      return this.properties;
    }

    return [
      activeProperty,
      ...this.properties.filter(
        (p) => p.propertyID !== activeProperty.propertyID
      )
    ];
  });

  sidebar: SidebarEsk;
  isSelectPropertyActive: boolean = false;
  selectedBoundariesCount: Number = 0;
  reports: Array<report> = [];
  helpStage: number = 1;
  selectedPaddocks: Map<string, PaddockDexie> = new Map();

  constructor() {
    createTour(this.tour);
  }

  ngOnInit() {
    this.geolocation = navigator.geolocation;
    this.propertyTool = false;

    this.mapService.createPropertyToolActive.subscribe();

    this.eventBusService.on(
      TreeMapperCustomEvents.FencesLoaded,
      (fences: FenceDexie[]) => {
        this.fences = fences;
      }
    );

    this.eventBusService.on(
      TreeMapperCustomEvents.PropertyFeaturesSelected,
      (features) => {
        this.populateCreatePropertyDefaults(features);
      }
    );

    (window as any).ol_map = this.mapService;

    let createPropertyStatusSub$ = this.mapService.ProcessingState.subscribe(
      (state) => {
        switch (state) {
          case 1:
            this.processing = false;
            break;
          case 2:
            this.processing = true;
            this.processingText = 'Creating Property';
            break;
          case 3:
            this.processing = true;
            this.processingText = 'Creating Paddock';
            break;
          case 4:
            this.processing = true;
            this.processingText = 'Clipping Layers';
            break;
          case 5:
            this.processing = true;
            this.processingText = 'Calculating Crop Suitability';
            break;
        }
      }
    );

    let clippingProgressLayerNameSub$ =
      this.mapService.ProgressDetail.subscribe((name) => {
        if (name == null) {
          return;
        }

        this.processingLayerText = name;
      });

    let userSub$ = this.authService.user.subscribe((user) => {
      this.user = user;
    });

    let propertySub$ = this.propertyService.activeProperty.subscribe(
      (property) => {
        this.reportingTargets.clear();
        // Note: activeProperty is now a signal, so we don't need to assign it here
        // The signal will automatically update when the service emits new values
      }
    );

    let propertiesSub$ = this.propertyService.properties.subscribe(
      (properties: any) => {
        if (properties == null) {
          return;
        }

        this.properties = properties;
      }
    );

    let paddocksSub$ = this.paddockService.paddocks.subscribe(
      (paddocks: any) => {
        this.selectedPaddocks.clear();

        this.paddocks = paddocks;
      }
    );

    this.subscriptions.add(createPropertyStatusSub$);
    this.subscriptions.add(clippingProgressLayerNameSub$);
    this.subscriptions.add(userSub$);
    this.subscriptions.add(propertySub$);
    this.subscriptions.add(propertiesSub$);
    this.subscriptions.add(paddocksSub$);
    this.mapService.addCadastreLayer();

    this.mapService.map.setTarget(this.mapElementRef.nativeElement);
    this.mapService.map.updateSize();

    this.route.paramMap.subscribe((params) => {
      let tool = params.get('tool');
      switch (tool) {
        case 'createProperty':
          this.propertyTool = true;
          this.sidebar.open('createProperty');
          break;
        case 'editProperty':
          this.propertyTool = true;
          this.sidebar.open('editProperty');
          break;
        case 'report':
          this.sidebar.open('reporting');
          break;
        case 'report-dss':
          this.sidebar.open('reporting');
          this.reportingToolType = 1;
          break;
        case 'report-npv':
          this.sidebar.open('reporting');
          this.reportingToolType = 2;
          break;

        case 'report-topex':
          this.sidebar.open('reporting');
          this.reportingToolType = 3;
          break;

        case 'report-woodlot':
          this.sidebar.open('reporting');
          this.reportingToolType = 4;
          break;

        case 'report-forest':
          this.sidebar.open('reporting');
          this.reportingToolType = 5;
          break;

        case 'help':
          this.sidebar.open('help');
      }
    });
  }

  ngAfterViewInit() {
    let showWelcome = true;

    if (localStorage.getItem('showWelcome')) {
      showWelcome = boolean(localStorage.getItem('showWelcome'));
    } else {
      localStorage.setItem('showWelcome', String(showWelcome));
    }

    if (showWelcome == true) {
      this.dialogManager.open(this.dialogRef());
    }

    this.mapService.map.on('moveend', () => {
      this.zoomLevel = this.mapService.map.getView().getZoom();
    });

    // this.sidebar.setOpenCallback( (openId)=> {
    //   if(openId == 'createProperty')
    //   {
    //     this.propertyService.activeProperty.next(null);
    //     this.mapService.setCreatePropertyToolActive(true);
    //     this.selectPropertyComponent.toggleSelectProperty();
    //   }
    //   else if(openId == 'paddocks')
    //   {
    //      if(!this.digitizePaddockComponent.active())
    //     this.digitizePaddockComponent.toggleDigitizePaddock();
    //   }
    //   else if(openId == 'fences')
    //   {/* Checking if the digitizeFenceComponent is active. */

    //     if(!this.digitizeFenceComponent.active())
    //     this.digitizeFenceComponent.toggleDigitizeFence();
    //   }
    //   else
    //   {
    //     this.mapService.setCreatePropertyToolActive(false);

    //     if(this.selectPropertyComponent.active)
    //     this.selectPropertyComponent.toggleSelectProperty();

    //     if(this.digitizePaddockComponent.active())
    //     this.digitizePaddockComponent.toggleDigitizePaddock();

    //     if(this.digitizeFenceComponent.active())
    //     this.digitizeFenceComponent.toggleDigitizeFence();

    //   }
    //   });

    // this.sidebar.setCloseCallback(() =>{

    //   this.mapService.setCreatePropertyToolActive(false);

    //     if(this.selectPropertyComponent.active)
    //     this.selectPropertyComponent.toggleSelectProperty();

    //   });

    this.mapService.addLayerSwitcher();
    this.mapService.setupBaseMaps();
    this.mapService.addDefaultControls();
    this.mapService.addDefaultInteractions();

    if (this.propertyTool) {
      //this.openSidebarPane('createProperty');
    } else {
    }

    if (this.activeProperty == null) {
    }
  }
  paddockToolClicked(active: boolean) {
    this.mapService.togglePropertyStyle(active);

    if (active) {
      this.sidebar.open('paddocks');
    }
  }

  fenceToolClicked(active: boolean) {
    this.mapService.togglePropertyStyle(active);

    if (active) {
      this.sidebar.open('fences');
    }
  }

  ngOnDestroy(): void {
    this.mapService.updateSize(null);
    this.mapService.removeControls();
    this.subscriptions.unsubscribe();
  }

  fenceCreated(data: FenceCreatedEvent) {
    this.activeFence = data.fence;
    this.activeFence.paddocks = [];

    this.activeFence.type = '';

    this.paddocks.forEach((paddock) => {
      if (data.intersectedPaddockIds.includes(paddock.paddockID)) {
        this.activeFence.paddocks.push(paddock.paddockID);
      }
    });

    const dialogRef = this.dialog.open(CreateFenceComponent, {
      hasBackdrop: true,
      data: { fence: this.activeFence, paddocks: this.paddocks },
      width: '40%'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === false) {
        return;
      }

      if (result instanceof FenceDexie) {
        this.activeFence = result;
        await this.saveFence();
      }
    });
  }

  reRenderMap() {
    this.mapService.map.render();
  }

  onFeatureSelected(feature) {
    this.attributeComponentRef = this.attributeOverlayTarget.createComponent(
      AttributeOverlayComponent
    );
    this.attributeComponentRef.instance.map = this.mapService.map;
    this.attributeComponentRef.instance.selectedFeature = feature;
    this.attributeComponentRef.instance.attributeAliasMap =
      this.mapService.propAliasMap;
  }

  populateCreatePropertyDefaults(selectedFeatures: Array<Feature<any>>) {
    this.selectedBoundariesCount =
      selectedFeatures?.length != null ? selectedFeatures.length : 0;

    if (selectedFeatures != null && selectedFeatures.length > 0) {
      let propertyIds = '',
        totalArea = 0;

      selectedFeatures.forEach((element) => {
        let props = element.getProperties();

        if (props.PID == null) {
        } else {
          propertyIds += !propertyIds.includes(props.PID)
            ? `${props.PID},`
            : '';
          totalArea =
            props.MEAS_AREA == 0
              ? totalArea + props.COMP_AREA
              : totalArea + props.MEAS_AREA;
        }
      });

      this.property.pid = propertyIds;
      this.property.area = parseFloat((totalArea / 10000).toFixed(2));
      this.featureSelected = true;
      this.selectedPropertyFeatures = selectedFeatures;
    } else {
      this.selectedPropertyFeatures = null;
      this.featureSelected = false;
      this.property = new PropertyDexie();
    }
  }

  toggleCreateProperty() {
    this.isSelectPropertyActive = !this.isSelectPropertyActive;

    this.selectPropertyComponent.toggleSelectProperty();
  }

  paddockChecked(paddock: PaddockDexie) {
    if (this.selectedPaddocks.has(paddock.paddockID)) {
      this.selectedPaddocks.delete(paddock.paddockID);
    } else {
      this.selectedPaddocks.set(paddock.paddockID, paddock);
    }
  }

  async showCropReport(targets: Array<PropertyDexie | PaddockDexie>) {
    let reports: Array<IDssReport> = [];

    for (let index = 0; index < targets.length; index++) {
      const element = targets[index];

      let reportData: EnterpriseReport;

      if (element instanceof PropertyDexie) {
        reportData = await this.enterpriseReportService.getPropertyReport(
          element.propertyID
        );
      } else {
        reportData = await this.enterpriseReportService.getPaddockReport(
          element.paddockID
        );
      }

      let report: IDssReport = {
        name: element.name,
        target: element,
        enterpriseReport: reportData,
        totalAreaNotCovered: 0
      };

      report.totalAreaNotCovered = parseFloat(
        (
          report.target.area -
          (report.enterpriseReport.data[0].wellSuited +
            report.enterpriseReport.data[0].unsuitable +
            report.enterpriseReport.data[0].moderatelySuitable +
            report.enterpriseReport.data[0].suitable)
        ).toFixed(3)
      );

      reports.push(report);
    }

    const dialogRef = this.dialog.open(DssReportComponent, {
      hasBackdrop: true,
      data: reports,
      width: '70%'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == null) {
        return;
      }
    });
  }

  openSidebarPane = (id) => {
    // this.sidebar?.open(id);

    // if (id == 'createProperty') {
    //   this.propertyService.activeProperty.next(null);
    //   this.mapService.setCreatePropertyToolActive(true);
    //   this.selectPropertyComponent.toggleSelectProperty();
    // }

    this.sidebarService.toggleComponentItem(id);
  };

  ZoomToPaddock(paddock: PaddockDexie) {
    this.mapService.zoomToPaddock(paddock);
  }

  openAbout() {
    this.dialog
      .open(AboutDialogComponent, { width: '30%' })
      .afterClosed()
      .subscribe((result) => {});
  }

  async saveProperty() {
    const dialogRef = this.dialog.open(CreatePropertyComponent, {
      hasBackdrop: true,
      data: this.property,
      width: '40%'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === false) {
        return;
      }

      if (result instanceof PropertyDexie) {
        this.property = result;
        await this.createProperty();
      }
    });
  }

  async createProperty() {
    await this.mapService.createProperty(
      this.property,
      this.selectedPropertyFeatures
    );
    this.property = new PropertyDexie();
    this.toggleCreateProperty();
    this.openSidebarPane('paddocks');
  }

  async editProperty(property: PropertyDexie) {
    this.propertyService.activeProperty.next(property);
    const dialogRef = this.dialog.open(EditPropertyComponent, {
      hasBackdrop: true,
      closeOnNavigation: true,
      data: property,
      width: '40%'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == null) {
        return;
      }

      if (result instanceof PropertyDexie) {
        this.updateProperty(result);
      } else if (result instanceof Object) {
        if (result.deleteProperty == true) {
          this.deleteProperty();
        }
      }
    });
  }

  async createPaddock(feature: Feature<any>) {
    let paddock = await this.mapService.CreatePaddock(feature);

    const dialogRef = this.dialog.open(CreatePaddockComponent, {
      hasBackdrop: true,
      data: paddock,
      width: '40%'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === false) {
        return;
      }

      if (result instanceof PaddockDexie) {
        await this.savePaddock(result);
      }
    });
  }

  async savePaddock(paddock: PaddockDexie) {
    this.digitizePaddockComponent.toggleDigitizePaddock();
    await this.mapService.createPaddock(paddock);
  }

  async editPaddock(paddock: PaddockDexie) {
    this.activePaddock = paddock;

    const dialogRef = this.dialog.open(EditPaddockComponent, {
      hasBackdrop: true,
      closeOnNavigation: true,
      data: paddock,
      width: '40%'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == null) {
        return;
      }

      if (result instanceof PaddockDexie) {
        this.updatePaddock(result);
      } else if (result instanceof Object) {
        if (result.deletePaddock == true) {
          this.deletePaddock(paddock);
        }
      }
    });
  }

  async deletePaddock(paddock: PaddockDexie) {
    this.paddockService.remove(paddock);
  }

  async discardFence() {
    this.activeFence = new FenceDexie();
  }

  async saveFence() {
    this.digitizeFenceComponent.toggleDigitizeFence();
    await this.mapService.createFence(this.activeFence);
  }
  async editFence(fence: FenceDexie) {
    this.activeFence = fence;

    const dialogRef = this.dialog.open(EditFenceComponent, {
      hasBackdrop: true,
      data: { fence: this.activeFence, paddocks: this.paddocks }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == null) {
        return;
      }

      if (result instanceof FenceDexie) {
        this.mapService.updateFence(result);
      } else if (result instanceof Object) {
        if (result.deleteFence == true) {
          this.mapService.deleteFence(this.activeFence);
        }
      }
    });
  }
  async updateFence() {
    await this.mapService.updateFence(this.activeFence);
  }

  cancelPaddockCreation() {
    this.mapService.createPaddockFeature.next(null);
  }
  updatePaddock(paddock) {
    this.paddockService.update(paddock);
  }

  updateProperty(property: PropertyDexie) {
    this.mapService.updateProperty(property);
  }

  deleteProperty() {
    const currentProperty = this.activeProperty();
    if (currentProperty) {
      this.mapService.deleteProperty(currentProperty);
    }
  }

  showNPVCalculator(targets: PropertyDexie | PaddockDexie) {
    this.reportingService.setReportTarget(targets);
    this.router.navigate(['/calculator']);
  }

  showWoodlotTool(targets: PropertyDexie | PaddockDexie) {
    this.reportingService.setReportTarget(targets);
    this.router.navigate(['/woodlot-tool']);
  }

  async showTopexReport(targets: Array<PropertyDexie | PaddockDexie>) {
    let reports: Array<ITopexReportData> = [];

    for (let index = 0; index < targets.length; index++) {
      const target = targets[index];

      let report =
        target instanceof PropertyDexie
          ? await this.topexReportService.getPropertyReport(target.propertyID)
          : await this.topexReportService.getPaddockReport(target.paddockID);

      let data = this.generateTopexReportDto(report, target);

      reports.push({ target: target, data: data });
    }
    const dialogRef = this.dialog.open(TopexReportComponent, {
      hasBackdrop: true,
      data: reports,
      width: '70%'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == null) {
        return;
      }
    });
  }

  async showForestReport(targets: Array<PropertyDexie | PaddockDexie>) {
    let reports: Array<IForestDescriptionReport> = [];

    for (let index = 0; index < targets.length; index++) {
      const target = targets[index];

      let report =
        target instanceof PropertyDexie
          ? await this.forestService.getPropertyReport(target.propertyID)
          : await this.forestService.getPaddockReport(target.paddockID);

      report.forestClasses = report.forestClasses
        ? report.forestClasses.filter((c) => c.area >= 0.1)
        : [];

      let object: IForestDescriptionReport = { target: target, report: report };

      reports.push(object);
    }
    const dialogRef = this.dialog.open(ForestDescriptionReportComponent, {
      hasBackdrop: true,
      data: reports,
      width: '70%'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == null) {
        return;
      }
    });
  }

  async showPineAnalysisReport(target: PropertyDexie | PaddockDexie) {
    let report =
      target instanceof PropertyDexie
        ? await this.peatService.getPropertyReport(target.propertyID)
        : await this.peatService.getPaddockReport(target.paddockID);

    let defaultVals = await this.peatService.getPeatDefaults();
    const erroredAccus = report.pineEconomicAnalysisAccuYieldRows
      .filter((a) => a.status !== 'Completed')
      .map((a) => a.accuYield);

    if (erroredAccus.length > 0) {
      const erroredTasks: AccuTaskResponse =
        await this.peatService.getAccuFromFailedPlos(
          report.coordinates,
          erroredAccus
        );

      const erroredAccu = this.peatService.processACCUData(erroredTasks);
      const updatedRows = new Map(erroredAccu.map((r) => [r.accuYield, r]));

      report.pineEconomicAnalysisAccuYieldRows =
        report.pineEconomicAnalysisAccuYieldRows.map((ex) => {
          const updated = updatedRows.get(ex.accuYield);

          if (!updated) {
            return ex;
          }

          return {
            ...ex,
            status: 'Completed',
            accuYieldAgeOfPlantation: updated.accuYieldAgeOfPlantation
          };
        });

      this.peatService.updateReportACCU(report, erroredAccu);
    }

    const ages = await this.peatService.getSiteCurveAndAges();
    const yields = await this.peatService.getSiteCurveAndYields();

    let object: PeatReport = {
      target: target,
      report: report,
      thinningHarvestAges: ages,
      thinningHarvestYields: yields,
      defaultValues: defaultVals
    };

    const dialogRef = this.dialog.open(PineEconomicAnalysisToolComponent, {
      hasBackdrop: true,
      data: object,
      width: '95vw',
      height: '95vh'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false || result == null) {
        return;
      }
    });
  }

  private generateTopexReportDto(report: TopexReport, target) {
    return [
      {
        topexScore: 10,
        exposureDescription: 'Severely Exposed',
        area: report.severelyExposed,
        percentage: (report.severelyExposed / target.area) * 100
      },
      {
        topexScore: 7,
        exposureDescription: 'Very Exposed',
        area: report.veryExposed,
        percentage: (report.veryExposed / target.area) * 100
      },
      {
        topexScore: 3,
        exposureDescription: 'Moderately Exposed',
        area: report.moderatelyExposed,
        percentage: (report.moderatelyExposed / target.area) * 100
      },
      {
        topexScore: 2,
        exposureDescription: 'Moderately Sheltered',
        area: report.moderatelySheltered,
        percentage: (report.moderatelySheltered / target.area) * 100
      },
      {
        topexScore: 0,
        exposureDescription: 'Very Sheltered',
        area: report.verySheltered,
        percentage: (report.verySheltered / target.area) * 100
      }
    ];
  }

  showHelpGuide() {}

  togglePropertyStyle() {}
  async open(id) {
    this.modalService.open(id);
  }

  locate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.mapService.setView(10, [
          position.coords.longitude,
          position.coords.latitude
        ]);
      });
    }
  }

  getSelectLayers() {
    return [...this.mapService.map.getAllLayers()];
  }

  deactivateProperty() {
    // Clear the active property
    this.propertyService.activeProperty.next(null);

    // Clear all spatial data layers
    this.mapService.clearLayers();

    // Clear any selected paddocks or other property-related data
    this.selectedPaddocks.clear();
    this.reportingTargets.clear();

    // Reset any property-related state
    this.activePaddock = new PaddockDexie();
    this.activeFence = new FenceDexie();

    console.log('Property deactivated and spatial data cleared');
  }
}
